import MuiCheckbox from "./MuiCheckbox";
import type { Store } from "./cart.types";

interface Badge {
    src: string;
    alt?: string;
}

interface Product {
    id: number;
    code: string;
    name: string;
    link: string;
    image: string;
    pack: string;
    badges?: string[];
    discount?: number;
    price: string;
    max: number;
    qty: number;
    checked: boolean;
    important: boolean;
}

interface StoreCheckboxProps {
    store: Store;
    onToggle: (id: number) => void;
}

function StoreCheckbox({ store, onToggle }: StoreCheckboxProps) {
    return (
        <div className="styles_cartStoreTopAction__uW164">
            <MuiCheckbox
                checked={store.checked}
                indeterminate={
                    store.products.some(p => p.checked) &&
                    !store.products.every(p => p.checked)
                }
                onChange={() => onToggle(store.id)}
            />
        </div>
    );
}


export default function CartContainer({
    stores,
    toggleStore,
    toggleProduct,
    changeQty,
    removeProduct,
    toggleImportant
}: {
    stores: Store[];
    toggleStore: (id: number) => void;
    toggleProduct: (storeId: number, productId: number) => void;
    changeQty: (storeId: number, productId: number, d: number) => void;
    removeProduct: (storeId: number, productId: number) => void;
    toggleImportant: (storeId: number, productId: number) => void;
}) {
    return (
        <div className="styles_cartList__KDbuH">

            {stores.map(store => (
                <div
                    key={store.id}
                    className="styles_cartStore__HcADi"
                    style={{ scrollMarginTop: "-330px" }}
                >

                    {/* ================= SHOP HEADER ================= */}
                    <div className="styles_cartStoreTop__0lxo2">

                        <a
                            className="styles_mobile_rootBase__8z7PQ styles_cartStoreTopInfo__1bkfc"
                            href={store.link}
                        >
                            <div className="styles_cartStoreImage__VO14L w-[32px] h-[32px]">
                                <img
                                    alt="image product"
                                    src={store.logo}
                                    style={{
                                        display: "block",
                                        minWidth: "100%",
                                        minHeight: "100%",
                                        maxWidth: "100%",
                                        maxHeight: "100%"
                                    }}
                                />
                            </div>

                            <div className="styles_cartStoreHeading__9yeym">
                                {store.name}
                            </div>
                        </a>

                        {/* checkbox shop */}
                        < StoreCheckbox store={store} onToggle={toggleStore} />
                    </div>

                    {/* =============== PRODUCTS =============== */}
                    <div className="MuiBox-root css-j7qwjs">

                        {store.products.map((product: Product) => (
                            <div
                                key={product.id}
                                className="MuiPaper-root MuiCard-root styles_card__R7fh2 MuiPaper-elevation1 MuiPaper-rounded"
                                id={product.code}
                            >

                                <div className="styles_cardMain__PljwK MuiBox-root css-0">

                                    {/* ⭐ mark important */}
                                    <div className="MarkItemAsImportant_cardWishList__eJZ3F MuiBox-root css-0">
                                        <span onClick={() => toggleImportant(store.id, product.id)}>
                                            <img
                                                alt="sản phẩm quan trọng"
                                                src={
                                                    product.important
                                                        ? "https://cdn-web-next.thuocsi.vn/images/cart/active_important_icon.svg"
                                                        : "https://cdn-web-next.thuocsi.vn/images/cart/inactive_important_icon.svg"
                                                }
                                            />
                                        </span>
                                    </div>

                                    {/* 🖼 image */}
                                    <div className="styles_cardImage__9LN5I">
                                        <a href={product.link}>
                                            <img
                                                alt={product.name}
                                                src={product.image}
                                                style={{ objectFit: "contain" }}
                                            />
                                        </a>
                                    </div>

                                    {/* TEXT */}
                                    <div className="styles_cardDesc__TRPvz">

                                        <a className="styles_cardTitle__OiNzy" href={product.link}>
                                            <span>{product.name}</span>
                                        </a>

                                        <div className="styles_cardStore__PJfqT">
                                            {product.pack}
                                        </div>

                                        <div className="styles_cardBadges__Ucbc0">
                                            {product.badges?.map((b: string) => (
                                                <img key={b} src={b} alt="" />
                                            ))}
                                        </div>
                                    </div>

                                    {/* PRICE */}
                                    <div className="MuiCardContent-root styles_cardPrice__Bm_A0">

                                        {product.discount && (
                                            <div className="styles_cardPriceItem__RGJxx">
                                                <div className="MuiChip-root styles_cardChip__m89pd MuiChip-sizeSmall">
                                                    <span className="MuiChip-label MuiChip-labelSmall">
                                                        -{product.discount}%
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        <div className="styles_cardPriceItem__RGJxx">
                                            <a className="styles_cardCurrentPrice__U8eC2" href={product.link}>
                                                <div>{product.price}đ</div>
                                            </a>
                                        </div>

                                        <div className="styles_cardPriceItem__RGJxx MuiBox-root css-0">
                                            <span className="styles_priceTextDiscount__F5k1h">Giá đã giảm</span>
                                        </div>
                                    </div>

                                    {/* ACTION BAR */}
                                    <div className="MuiCardActions-root styles_cardActions__4cb9z MuiCardActions-spacing">

                                        <div className="styles_cardActionsItem__JAjvz">
                                            <span className="styles_cardNoted__qtjUy">
                                                Đặt tối đa {product.max} sản phẩm
                                            </span>
                                        </div>

                                        <div className="styles_cardActionsItem__JAjvz">
                                            <div className="styles_container__3SoFg">

                                                <div
                                                    className="styles_minusContainerNew__8hlZU"
                                                    role="button"
                                                    onClick={() => changeQty(store.id, product.id, -1)}
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8H15" stroke="#333333" stroke-width="2" stroke-linecap="round"></path></svg>
                                                </div>

                                                <div className="styles_groupInput__D0r99 cart-qty-control-input-group">
                                                    <div className="styles_cartIconContainer__7aY_l">
                                                        <div className="styles_inputVisible__By2Hp">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 18" fill="none">
                                                                <path d="M14.3608 3.9375H4.00136L3.11622 2.35095C3.01687 2.17287 2.82892 2.0625 2.625 2.0625H1.5C1.18934 2.0625 0.9375 2.31434 0.9375 2.625C0.9375 2.93566 1.18934 3.1875 1.5 3.1875H2.2947L3.16822 4.75324L5.18278 9.21066L5.18484 9.21521L5.36228 9.60781L3.33965 11.7653C3.19422 11.9204 3.14869 12.1443 3.22199 12.3439C3.29529 12.5435 3.47488 12.6847 3.68614 12.7089L5.52974 12.9196C7.83575 13.1831 10.1643 13.1831 12.4703 12.9196L14.3139 12.7089C14.6225 12.6736 14.8442 12.3948 14.8089 12.0861C14.7736 11.7775 14.4948 11.5559 14.1861 11.5911L12.3425 11.8018C10.1214 12.0557 7.87861 12.0557 5.65749 11.8018L4.92585 11.7182L6.41038 10.1347C6.42474 10.1194 6.43808 10.1035 6.45039 10.0871L7.015 10.1605C7.8062 10.2635 8.60596 10.2837 9.40134 10.2208C11.2564 10.074 12.9758 9.19131 14.1761 7.7693L14.6097 7.25569C14.6242 7.23844 14.6377 7.22033 14.6501 7.20146L15.4581 5.97007C16.0309 5.09724 15.4048 3.9375 14.3608 3.9375Z" fill="#999999">
                                                                </path>
                                                                <path d="M4.875 13.875C4.25368 13.875 3.75 14.3787 3.75 15C3.75 15.6213 4.25368 16.125 4.875 16.125C5.49632 16.125 6 15.6213 6 15C6 14.3787 5.49632 13.875 4.875 13.875Z" fill="#999999">
                                                                </path>
                                                                <path d="M12 15C12 14.3787 12.5037 13.875 13.125 13.875C13.7463 13.875 14.25 14.3787 14.25 15C14.25 15.6213 13.7463 16.125 13.125 16.125C12.5037 16.125 12 15.6213 12 15Z" fill="#999999"></path>
                                                            </svg>
                                                        </div>
                                                        <span className="styles_currentValue__PzTgx">{product.qty}</span>
                                                    </div>
                                                    <div className="MuiInput-root MuiInputBase-root MuiInputBase-colorPrimary styles_newCardInput__0QItk cart-qty-control-input css-1f63zq5">
                                                        <input type="number" className="MuiInput-input MuiInputBase-input css-mnn31" value={product.qty} />
                                                    </div>
                                                </div>
                                                <div
                                                    className="styles_addContainerNew__lteuA"
                                                    role="button"
                                                    onClick={() => changeQty(store.id, product.id, 1)}
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 15V1M1 8L15 8" stroke="#005c29" stroke-width="2" stroke-linecap="round"></path></svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* remove + checkbox right */}
                                    <div className="MuiCardActions-root styles_cartEvents__rilD_ MuiCardActions-spacing">

                                        <div
                                            className="RemoveItemInCart_cartRemove__RraHh"
                                            title="Xóa Sản Phẩm"
                                            onClick={() => removeProduct(store.id, product.id)}
                                        >
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.22866 14.3957C7.47053 14.3957 7.67683 14.3094 7.84756 14.1367C8.01829 13.9496 8.10366 13.7338 8.10366 13.4892V8.09352C8.0752 7.8777 7.97561 7.69784 7.80488 7.55396C7.63415 7.39568 7.43496 7.31655 7.20732 7.31655C6.9939 7.31655 6.80183 7.39568 6.6311 7.55396C6.46037 7.69784 6.36077 7.8777 6.33232 8.09352V13.4892C6.33232 13.7338 6.41768 13.9496 6.58841 14.1367C6.77337 14.3094 6.98679 14.3957 7.22866 14.3957ZM16.1067 3.60432H12.564V2.69784C12.564 2.20863 12.4431 1.76259 12.2012 1.35971C11.9594 0.942445 11.6321 0.61151 11.2195 0.366906C10.8211 0.122302 10.3801 0 9.89634 0H8.10366C7.61992 0 7.17175 0.122302 6.75915 0.366906C6.36077 0.61151 6.04065 0.942445 5.79878 1.35971C5.55691 1.76259 5.43598 2.20863 5.43598 2.69784V3.60432H1.89329C1.67988 3.63309 1.49492 3.73381 1.33841 3.90647C1.19614 4.07914 1.125 4.28058 1.125 4.51079C1.125 4.72662 1.19614 4.92086 1.33841 5.09352C1.49492 5.26619 1.67988 5.36691 1.89329 5.39568H2.76829V15.3022C2.76829 15.7914 2.88923 16.2374 3.1311 16.6403C3.37297 17.0576 3.69309 17.3885 4.09146 17.6331C4.50407 17.8777 4.95224 18 5.43598 18H12.564C13.0478 18 13.4888 17.8777 13.8872 17.6331C14.2998 17.3885 14.627 17.0576 14.8689 16.6403C15.1108 16.2374 15.2317 15.7914 15.2317 15.3022V5.39568H16.1067C16.3201 5.36691 16.498 5.26619 16.6402 5.09352C16.7967 4.92086 16.875 4.72662 16.875 4.51079C16.875 4.28058 16.7967 4.07914 16.6402 3.90647C16.498 3.73381 16.3201 3.63309 16.1067 3.60432ZM7.22866 2.69784C7.22866 2.45324 7.31402 2.2446 7.48476 2.07194C7.65549 1.89928 7.86179 1.81295 8.10366 1.81295H9.89634C10.1382 1.81295 10.3445 1.89928 10.5152 2.07194C10.686 2.2446 10.7713 2.45324 10.7713 2.69784V3.60432H7.22866V2.69784ZM13.439 15.3022C13.439 15.5468 13.3537 15.7554 13.1829 15.9281C13.0122 16.1007 12.8059 16.187 12.564 16.187H5.43598C5.19411 16.187 4.9878 16.1007 4.81707 15.9281C4.64634 15.7554 4.56098 15.5468 4.56098 15.3022V5.39568H13.439V15.3022ZM10.7713 14.3957C11.0132 14.3957 11.2195 14.3094 11.3902 14.1367C11.5752 13.9496 11.6677 13.7338 11.6677 13.4892V8.09352C11.6392 7.8777 11.5396 7.69784 11.3689 7.55396C11.1982 7.39568 10.999 7.31655 10.7713 7.31655C10.5579 7.31655 10.3659 7.39568 10.1951 7.55396C10.0244 7.69784 9.9248 7.8777 9.89634 8.09352V13.4892C9.89634 13.7338 9.98171 13.9496 10.1524 14.1367C10.3232 14.3094 10.5295 14.3957 10.7713 14.3957Z" fill="#494949"></path></svg>
                                        </div>

                                        <div
                                            className="SelectItem_cartCheckBox__FE9_K"
                                            title="Chọn Sản Phẩm"
                                        >
                                            <MuiCheckbox
                                                checked={product.checked}
                                                indeterminate={false}
                                                onChange={() => toggleProduct(store.id, product.id)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* FOOTER VOUCHER BAR */}
                    <div className="MuiBox-root css-4r1lgk" style={{ margin: "16px" }}>
                        <div className="MuiBox-root css-axw7ok">
                            <img
                                alt="suggest icon"
                                src="https://cdn-web-next.thuocsi.vn/images/cart/suggest_voucher_icon.svg"
                            />
                            <div className="styles_suggestText__Li4Vi">
                                {store.voucherText}
                            </div>
                        </div>
                        <div className="styles_suggestButton__JgX7R MuiBox-root css-0">
                            <span> Mua thêm </span>
                            <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="KeyboardArrowRightIcon">
                                <path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path>
                            </svg>
                        </div>
                    </div>

                </div >
            ))
            }
        </div >
    );
}
